{
  "#DELIVERY_NOTE": {
    "TITLE": "Lieferscheine",
    "OVERVIEW": {
      "TITLE": "Auslieferungen",
      "SEGMENTS": {
        "LIEFERSCHEINE": "Lieferscheine",
        "MATERIALSCHEINE": "Materialscheine"
      },
      "SEARCH": {
        "PLACEHOLDER_LIEF": "Lieferscheine suchen",
        "PLACEHOLDER_MAT": "Materialscheine suchen"
      },
      "EMPTY": {
        "LIEFERSCHEINE": "Keine Lieferscheine vorhanden",
        "MATERIALSCHEINE": "Keine Materialscheine vorhanden",
        "NO_DATA": "Keine Daten für das ausgewählte Datum vorhanden"
      }
    },
    "DETAILS": {
      "DELIVERY_NOTE": "Lieferschein",
      "MATERIAL_NOTE": "Materialschein",
      "CONSTRUCTION_SITE": "Auslieferung",
      "VERMERK_TITLE": "Vermerk",
      "DELIVERY_INFO_TITLE": "Lieferhinweis",
      "SIGNATURE": {
        "OVERLINE": "Unterschrift",
        "TAP_TO_ADD_INFO": "Tippen Sie hier um eine Unterschrift hinzuzufügen"
      }
    },
    "RETOUR": {
      "TITLE": "Retourschein erstellen",
      "VALIDATION_CHECK_QTY": "Bitte Mengen überprüfen!",
      "EMBALLAGEN": "Emballagen",
      "VERMERKITEMS": "Vermerk-Artikel",
      "SEARCH": "Retour-Artikel von ausgelieferten Belegen",
      "SCAN": "Retour-Artikel gescannt",
      "ADD_POSITION_LABEL": "Position hinzufügen",
      "COMMENT": "Anmerkung",
      "ADD_COMMENT": "Anmerkung hinzufügen",
      "PRIMARY_BUTTON": "Retourschein speichern",
      "LIST_ITEM_QTY_SUFFIX": "angeliefert"
    },
    "MODAL": {
      "CONFIRM_ACTION": "Bist du sicher?"
    },
    "DIALOGS": {
      "SIGNATURE": {
        "SAVE": "Speichern",
        "ABORT": "Abbrechen",
        "TITLE": "Unterschrift",
        "TIMESTAMP_LABEL": "Abladezeitpunkt",
        "TIMESTAMP_TEXT": "Uhrzeit beim Abladen",
        "SIGN_LABEL": "Bitte unterschreiben Sie im Feld:",
        "CLOCK_UNIT": "UHR",
        "MISSING_PERMISSION": "Sie sind nicht Berechtigt den Auftrag abzuschließen!"
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Änderungen speichern?",
        "TEXT": "Es wurde festgestellt, dass es ungesicherte Änderungen gab. Zum Speichern wird eine Internetverbindung benötigt. Wollen Sie diese Änderungen speichern oder verwerfen?",
        "SAVE": "Anderungen speichern",
        "CANCEL": "Änderungen verwerfen"
      },
      "ADD_ITEM": {
        "TITLE": "Artikel hinzufügen",
        "SEARCH_PLACEHOLDER": "Artikelnummer oder Bezeichnung",
        "QTY_PLACEHOLDER": "Menge",
        "SUBMIT": "Hinzufügen",
        "CANCEL": "Schließen"
      },
      "BOTTOM_SHEET": {
        "TITLE": "Aktion auswählen",
        "TEXT_1": "Bitte wählen Sie eine Aktion für den Artikel",
        "TEXT_2": "aus!"
      },
      "RETOUR_IMAGE": {
        "TITLE": "Bild auswählen/aufnehmen",
        "SAVE": "Speichern",
        "ABORT": "Abbrechen"
      },
      "EDIT_IMAGE": {
        "TITLE_MULTIPLE": "Bilder bearbeiten",
        "TITLE_SINGLE": "Bild bearbeiten",
        "EMPTY_PLACEHOLDER": "Es sind keine Bilder mehr vorhanden"
      },
      "RETOUR_SAVE_CHANGES_DIALOG": {
        "QUESTION": "Sollen alle Änderungen am Retourschein gespeichert werden?"
      },
      "RETOUR_CLEAR_CHANGES_DIALOG": {
        "QUESTION": "Wollen Sie wirklich alle bisher von Ihnen vorgenommenen Änderungen verwerfen?"
      },
      "COMMENT": {
        "TITLE_ADD": "Vermerk hinzufügen",
        "TITLE_ADD_ITEM": "Vermerk-Artikel hinzufügen",
        "TITLE_EDIT": "Vermerk bearbeiten",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "CLOSE": {
        "CUSTOMER_EMAIL": "E-Mail Belegversand",
        "INFO_MAX_MENGE": "Die Menge überschreitet die maximal zulässige Menge, möchten Sie dennoch fortfahren?",
        "TITLE": "Auslieferung abschließen",
        "TILE_MAX_MENGE": "Maximale Menge erreicht",
        "KILOMETERS_LABEL": "Kilometerstand",
        "CLOSE_HEADLINE": "Auslieferung wirklich abschließen?",
        "CLOSE_TEXT": "Nach dem Abschluss können keine Änderungen mehr vorgenommen werden und die Auslieferung verschwindet aus der Übersicht!",
        "KILOMETERS_UNIT": "KM",
        "SUBMIT": "Abschließen",
        "CANCEL": "Abbrechen",
        "SAVE_AND_CANCEL": "Speichern und Abbrechen",
        "CONTINUE": "Fortfahren"
      }
    },
    "HEADERS": {
      "PHOTOS": "Fotos",
      "CLIENT": "Kunde",
      "MATERIALS": "Materialschein",
      "DELIVERY": "Lieferschein",
      "RETURN": "Retourschein"
    },
    "MESSAGES": {
      "OVERVIEW_SCAN_SUCCESS": {
        "TITLE": "Hinzufügen erfolgreich",
        "MESSAGE": "Der gescannte Lieferschein wurde erfolgreich hinzugefügt."
      },
      "DETAILS_SAVE_SUCCESS": {
        "TITLE": "Speichern erfolgreich",
        "MESSAGE": "Änderungen wurden erfolgreich gespeichert"
      },
      "DETAILS_SAVE_ERROR": {
        "TITLE": "Speichern fehlgeschlagen",
        "MESSAGE": "Die Änderungen konnten nicht gespeichert werden."
      },
      "DETAILS_CLOSE_SUCCESS": {
        "TITLE": "Lieferschein abgeschlossen",
        "MESSAGE": "Der Lieferschein wurde erfolgreich abgeschlossen!"
      },
      "RETOUR_VALIDATION_QTY": {
        "TITLE": "Bitte Mengen überprüfen!",
        "MESSAGE": "Bitte stellen Sie sicher, dass alle Positionen mit einer Menge korrekt sind. Die Menge darf die angelieferte Menge nicht überschreiten und nicht kleiner als 0 sein!"
      }
    }
  }
}
